import { TOKEN_KEY } from "@/lib/api";

/* Fase 10 — Support Mode (impersonación segura).
 * El token de impersonación lleva sub=usuario objetivo y act={admin} (RFC 8693).
 * El token admin original se guarda aparte y se restaura al salir. */

export const ADMIN_BACKUP_KEY = "aos_support_admin_token";

export function decodeJwt(token) {
  try {
    const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

/** Claims del token actual si es una sesión de Support Mode; null si no. */
export function impersonationClaims() {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) return null;
  const payload = decodeJwt(token);
  return payload?.impersonation ? payload : null;
}

export function beginSupportSession(impersonationToken) {
  localStorage.setItem(ADMIN_BACKUP_KEY, localStorage.getItem(TOKEN_KEY) || "");
  localStorage.setItem(TOKEN_KEY, impersonationToken);
}

export function restoreAdminSession() {
  const backup = localStorage.getItem(ADMIN_BACKUP_KEY);
  if (backup) {
    localStorage.setItem(TOKEN_KEY, backup);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
  localStorage.removeItem(ADMIN_BACKUP_KEY);
}
